import React from 'react';
import {
  EmptyIllustrationFrame,
  EmptyIllustrationGroundShadow,
  EmptyIllustrationMiniCard,
  EmptyIllustrationSvg,
} from './empty-illustration';

export const TimelineEmptyIllustration: React.FC = () => {
  return (
    <EmptyIllustrationFrame>
      <EmptyIllustrationSvg>
        <EmptyIllustrationGroundShadow rx={58} />
        <line x1="28" y1="140" x2="212" y2="140" stroke="var(--border)" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="48" y1="134" x2="48" y2="146" stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="88" y1="134" x2="88" y2="146" stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="152" y1="134" x2="152" y2="146" stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="192" y1="134" x2="192" y2="146" stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="56" y1="140" x2="56" y2="86" stroke="var(--border)" strokeWidth="2" strokeLinecap="round" />
        <line x1="120" y1="140" x2="120" y2="50" stroke="var(--scribane-green)" strokeWidth="2" strokeLinecap="round" />
        <line x1="184" y1="140" x2="184" y2="78" stroke="var(--muted-foreground)" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
        <circle cx="56" cy="140" r="4.5" fill="var(--card)" stroke="var(--border)" strokeWidth="2" />
        <circle cx="120" cy="140" r="4.5" fill="var(--scribane-green)" />
        <circle cx="184" cy="140" r="4.5" fill="var(--card)" stroke="var(--border)" strokeWidth="2" />
        <EmptyIllustrationMiniCard x={38} y={54} variant="a" tone="muted" width={36} height={26} />
        <EmptyIllustrationMiniCard x={102} y={18} variant="b" tone="filled" width={36} height={26} />
        <EmptyIllustrationMiniCard x={166} y={46} variant="c" tone="outline-green" width={36} height={26} />
      </EmptyIllustrationSvg>
    </EmptyIllustrationFrame>
  );
};
